// extracted by mini-css-extract-plugin
export default {"private-wrapper":"PrivateRoute_private-wrapper__N8FQU"};